// Import CSS
import "./QuickTextTemplateModal.css";

import useQuickTextTemplateModal from "./useQuickTextTemplateModal";
import { Box, TextField } from "@mui/material";

import { useFormik } from "formik";
import * as Yup from "yup";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const validationSchema = Yup.object().shape({
  title: Yup.string().label("Title").required(),
  description: Yup.string().label("Description").required(),
});

const QuickTextTemplateModal = () => {
  const {
    showModal,
    modalTitle,
    onClose,
    handleAdd,
    handleUpdate,
    selectedTemplate,
  } = useQuickTextTemplateModal();

  const formik = useFormik({
    initialValues: {
      title: selectedTemplate?.title || "",
      description: selectedTemplate?.description || "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (selectedTemplate?._id) {
        await handleUpdate(values);
      } else {
        await handleAdd(values);
      }
    },
  });

  const {
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    setFieldTouched,
    handleSubmit,
    isSubmitting,
  } = formik;

  return (
    <div>
      <ModalWrapper
        show={showModal}
        onClose={onClose}
        title={modalTitle}
        showContentDivider
        actionButtons={[
          {
            label: "Cancel",
            variant: "outlined",
            onClick: () => onClose(),
            style: {
              color: "#949494",
              borderColor: "#E0E0E0",
              padding: "8px 16px",
            },
          },
          {
            label: "Save",
            variant: "contained",
            disabled: isSubmitting,
            isLoading: isSubmitting,
            onClick: handleSubmit,
            style: {
              padding: "8px 16px",
            },
          },
        ]}
      >
        <Box className="d-flex flex-column" marginTop={2} gap={2}>
          <TextField
            name="title"
            label="Title"
            fullWidth
            margin="none"
            required
            value={values.title}
            onChange={handleChange}
            onBlur={(e) => {
              const trimmed = e.target.value.trim();
              setFieldTouched("title", true);
              setFieldValue("title", trimmed);
            }}
            error={touched.title && Boolean(errors.title)}
            helperText={touched.title && errors.title}
            inputProps={{
              maxLength: 50,
            }}
            sx={{
              "& .MuiInputLabel-asterisk": {
                color: "#EF5350",
              },
            }}
          />

          <TextField
            name="description"
            label="Description"
            fullWidth
            margin="none"
            multiline
            rows={6}
            value={values.description}
            onChange={handleChange}
            required
            onBlur={(e) => {
              const trimmed = e.target.value.trim();
              setFieldTouched("description", true);
              setFieldValue("description", trimmed);
            }}
            error={touched.description && Boolean(errors.description)}
            helperText={touched.description && errors.description}
            inputProps={{
              maxLength: 500,
            }}
            sx={{
              "& .MuiInputLabel-asterisk": {
                color: "#EF5350",
              },
            }}
          />
        </Box>
      </ModalWrapper>
    </div>
  );
};

export default QuickTextTemplateModal;
